import request from '@/utils/request';

export default {
  getList: params => request.get('/business/tbshop', { params }),
  add: data => request.post('/business/tbshop', data),
  detail: id => request.get(`/business/tbshop/${id}`),
  offline: id => request.put(`/business/tbshop/offline/${id}`),
  itemdetail: id => request.get(`/business/tbitem/${id}`)
};
